import React, { useMemo } from 'react';
import { Card, Loading, Right, Box, Heading, RouterLink } from '../core';
import { Stats } from '../Stats';
import { IChain } from '@sc1/common/utils';
import { getCustomVaultName, getVaultType } from '@sc1/common/vaults';
import { useVaultSubgraph } from '@sc1/common/hooks';
import { getVaultPath, vaultTypeToSlug } from '../../utils';

export const VaultPreview = ({
  chain,
  symbol,
  vaultAddress,
}: {
  chain: IChain;
  vaultAddress: string;
  symbol?: string;
}): JSX.Element | null => {
  const { loading, data } = useVaultSubgraph(chain, vaultAddress);
  const { vault } = data || {};
  const customName = getCustomVaultName(vault?.name ?? symbol);

  const vaultTypeSlug = useMemo(() => {
    const vaultType = getVaultType(chain, vaultAddress);
    return vaultTypeToSlug(vaultType);
  }, [chain, vaultAddress]);

  const path = getVaultPath(vaultAddress, vaultTypeSlug) + `?chain=${chain}`;
  return (
    <RouterLink sx={{ color: 'inherit', textDecoration: 'inherit' }} to={path}>
      <Card mb={3}>
        <Loading loading={loading}>
          <Box sx={{ position: 'relative' }}>
            <Heading as="h2">{customName}</Heading>
            <Stats data={vault} chain={chain} />
            <Right
              sx={{ top: '50%', mt: '-14px', right: -20, position: 'absolute' }}
            />
          </Box>
        </Loading>
      </Card>
    </RouterLink>
  );
};
